




















































































































































































import SectionCard from "@/components/SectionCard.vue";
import PairRow from "@/components/PairRow.vue";
import Organizers from "@/components/Organizers.vue";
import Journals from "@/components/Journals.vue";
import SectionsContainer from "../mixins/sections-container";
import Calendario from "../components/Calendario.vue";
import Agenda from "../components/Agenda.vue";
import PagoInscripcion from "../components/PagoInscripcion.vue";
import miembrosRedis from "../components/MiembrosRedis.vue";
import API from "../services/api";
import Conferencistas from "../components/Conferencistas.vue";
import Talleres from "../components/Talleres.vue";
import { mapState } from "vuex";

export interface Network {
  icon: string;
  url: string;
  label: string;
  color: string;
}

export interface HomeComponentData {
  presentacionImagen: string;
  images: string[];
  social: Network[];
  selectEva: boolean;
  linkInstructivo: string;
  linkprog_general: string;
  linkprog_ponencias: string;
}

export default SectionsContainer.extend({
  components: {
    SectionCard,
    PairRow,
    Organizers,
    Calendario,
    Agenda,
    PagoInscripcion,
    Conferencistas,
    miembrosRedis,
    Talleres,
    Journals,
  },

  data: (): HomeComponentData => ({
    presentacionImagen: "/images/presentacion/cacied2025.png",
    images: [
      "/images/banners/0.png",
      "/images/banners/1.png",
      "/images/banners/2.png",
      "/images/banners/3.png",
      "/images/banners/4.png",
      "/images/banners/5.png",
      "/images/banners/6.png",
      "/images/banners/7.png",
      "/images/banners/8.png",
      "/images/banners/9.png",
    ],
    social: [
      {
        icon: "mdi-facebook",
        url: "https://www.facebook.com/share/14FFscv44j8/",
        label: "Facebook",
        color: "#1877f2",
      },
      {
        icon: "mdi-instagram",
        url: "https://www.instagram.com/caciedcongreso?igsh=MWhweG83ajBrYWozNA==",
        label: "Instagram",
        color: "#fc146f",
      },
    ],
    selectEva: false,
    linkInstructivo: API.getUrl("/instructivo.pdf"),
    linkprog_general: API.getUrl("/prog_general.pdf"),
    linkprog_ponencias: API.getUrl("/prog_ponencias.pdf"),
  }),

  computed: {
    ...mapState("session", ["viewedHomeDialog"]),
    showModal: {
      get() {
        return !this.viewedHomeDialog;
      },

      set(v: boolean) {
        this.$store.commit("session/setViewedHomeDialog", !v);
      },
    },
  },
});
